export default __webpack_public_path__ + "static/media/carousel1.8c8a686e.jpg";